import type { App } from 'vue';
import PrimeVue from 'primevue/config';

import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const CustomPreset = definePreset(Aura, {
  components: {
    progressspinner: {
      root: {
        colorOne: '{red.500}',
        colorTwo: '{blue.500}',
        colorThree: '{green.500}',
        colorFour: '{yellow.500}',
      },
    },
  },
});

export default function registerPluginPrimeVue(app: App): void {
  app.use(PrimeVue, {
    theme: {
      preset: CustomPreset,
      options: {
        darkModeSelector: false,
        prefix: 'p',
        cssLayer: {
          name: 'primevue',
          order: 'tailwind-base, primevue, tailwind-utilities',
        },
      },
    },
    ripple: false,
    inputVariant: 'filled',
  });
}
